import { type ReactNode } from 'react';
import styles from './Heading.module.css';

interface IHeadingProps {
  label?: ReactNode;
  description?: ReactNode;
}

const Heading = ({ label, description }: IHeadingProps) => (
  <div className={styles.heading}>
    <p>{label}</p>
    {description ? <p className={styles.description}>{description}</p> : null}
  </div>
);

export default Heading;
